import React from 'react';
import styled from 'styled-components/macro';
import { Row, Col } from '../../../../grid';

const StyledRow = styled(Row)`
  margin-top: ${({ big }) => (big ? '10px' : '0px')};
`;

const RenderProductPageDescriptionLong = ({
  productPageDescriptionLong,
  big,
}) => {
  if (productPageDescriptionLong) {
    return (
      <StyledRow white big={big}>
        <Col xs={12}>
          {productPageDescriptionLong()}
        </Col>
      </StyledRow>
    );
  }
  return (null);
};

// Export
export default RenderProductPageDescriptionLong;
